export function isNonEmptyObject(
  value: unknown
): value is Record<string, unknown> {
  return (
    typeof value === 'object' && value !== null && Object.keys(value).length > 0
  );
}
